import React, { type FC } from 'react';

import LoginContainer from './LoginContainer';
import LoginForm from './LoginForm';

const Login: FC = () => (
  <LoginContainer>
    <LoginForm />
  </LoginContainer>
);

export default Login;
